module.exports = __webpack_public_path__ + "img/16_114.4c0fdfee.png";